cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {

        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }

    };

    var PM_pmc_productpromotion_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
          let auditStatusModel = viewmodel.get('actityItemType');
          let dataSource = auditStatusModel.getState('dataSource');
          //viewmodel.get("temporary").setState('defaultSelectedRowIndexes', true);

            const displayField = (fieldmap) => {
                for (var key in fieldmap) {
                    viewmodel.get("productPreferentialPro").setColumnState(key, "bShowIt", fieldmap[key]);
                }
            }

            const displayIsGetmemberPrice = (viewmodel) => {
                if (viewmodel.get("bMemberLevelAll").getValue() == 0 && viewmodel.get("productPreferentialMemberL").getShowValue()
                    && viewmodel.get("productPreferentialMemberL").getShowValue().length == 1) {
                    viewmodel.get("isGetmemberPrice").setDisabled(false);
                } else {
                    viewmodel.get("isGetmemberPrice").setValue(false);
                    viewmodel.get("isGetmemberPrice").setDisabled(true);
                }
            }

            const displayBatchControl = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('enableBatchControl').setVisible(true);
                } else {
                    viewmodel.get('enableBatchControl').setVisible(false);
                    viewmodel.get('enableBatchControl').setValue(0);
                }
                if (viewmodel.get('actityItemType').getValue() == 0) {
                    viewmodel.get('enableBatchControl').setDisabled(false);
                } else {
                    viewmodel.get('enableBatchControl').setDisabled(true);
                    viewmodel.get('enableBatchControl').setValue(0);
                }
                displayBatchNo(viewmodel);
            }

            const displayBatchNo = (viewmodel) => {
                let productPreferentialPro = viewmodel.get('productPreferentialPro');
                // let rows = productPreferentialPro.getRows();
                // rows.forEach(function (row, index) {
                //     productPreferentialPro.setCellValue(index, 'batchNo', null);
                // });
                productPreferentialPro.setColumnState('batchNo', 'bShowIt', viewmodel.get('enableBatchControl').getValue() == 1);
            }

            const displayActityItemType = (viewmodel) => {
                if (viewmodel.get('enableBatchControl').getValue() == 0) {
                    viewmodel.get('actityItemType').setDisabled(false);
                } else {
                    viewmodel.get('actityItemType').setDisabled(true);
                }
            }

            const displayPreferentialPro = (viewmodel) => {
                let PreferentialPro = viewmodel.get('productPreferentialPro');
                let rows = PreferentialPro.getRows();
                let enableArchiveDeposite = viewmodel.get("enableArchiveDeposite").getValue();
                rows.forEach(function (row, index) {
                    if (viewmodel.get('actityItemType').getValue() == 0) {
                        if (!row.enableDeposit) {
                            PreferentialPro.setCellState(index, 'deposits', 'disabled', true);
                        } else {
                            // if (enableArchiveDeposite) {
                            //     PreferentialPro.setCellState(index, 'deposits', 'disabled', true);
                            // } else {
                            //     PreferentialPro.setCellState(index, 'deposits', 'disabled', false);
                            // }
                            PreferentialPro.setCellState(index, 'deposits', 'disabled', 1 == enableArchiveDeposite);
                        }
                    }
                    if (row.lType != 4 && row.lTypeNum != null) {
                        PreferentialPro.setCellValue(index, 'lTypeNum', null);
                    }
                })
            }

            const checkTotalQuantity = (viewmodel, isInit) => {
                let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                if (applyOnlineChannel) {
                    viewmodel.get("productPreferentialPro").getEditRowModel().get('totalQuantity').setState('iNumPoint', 0);
                    for (let i = 0; i < viewmodel.get("productPreferentialPro").getRows().length; i++) {
                        if (!isInit) {
                            if (viewmodel.get("productPreferentialPro").getRows()[i].totalQuantity && !(/^-?[1-9]\d*$/).test(viewmodel.get("productPreferentialPro").getRows()[i].totalQuantity)) {
                                viewmodel.get("productPreferentialPro").setCellValue(i, 'totalQuantity', Math.floor(viewmodel.get("productPreferentialPro").getRows()[i].totalQuantity));
                            }
                        }
                    }
                } else {
                    viewmodel.get("productPreferentialPro").getEditRowModel().get('totalQuantity').setState('iNumPoint', 2);
                }
            }

          const actityItemTypeArray =
            [{
              "value": "0",
              "text": "商品",
              "nameType": "text"
            },
              {
                "value": "1",
                "text": "商品分类",
                "nameType": "text"
              },
              {
                "value": "2",
                "text": "商品标签",
                "nameType": "text"
              }];

            const displayPrice = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "lProductId": "id",
                        "sProductName": "cName",
                        "sProductCode": "code",
                        "dPrice": "fMarkPrice",
                        "sProductPicUrl": "url",
                        "enableDeposit": "enableDeposit",
                        "deposits": "deposits",
                        "cDescribe": "modelDescription"
                    };
                    let sku_refRetId = {
                        "lProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "dPrice": "fMarkPrice",
                        "sProductPicUrl": "productUrl",
                        "enableDeposit": "enableDeposit",
                        "deposits": "deposits",
                        "cDescribe": "specs"
                    };
                    viewmodel.get("productPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("productPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                } else {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "lProductId": "id",
                        "sProductName": "cName",
                        "sProductCode": "code",
                        "dPrice": "fSalePrice",
                        "sProductPicUrl": "url",
                        "enableDeposit": "enableDeposit",
                        "deposits": "deposits",
                        "cDescribe": "modelDescription"
                    };
                    let sku_refRetId = {
                        "lProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "dPrice": "salePrice",
                        "sProductPicUrl": "productUrl",
                        "enableDeposit": "enableDeposit",
                        "deposits": "deposits",
                        "cDescribe": "specs"
                    };
                    viewmodel.get("productPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("productPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                }
            }

            const displayiAreaId = (viewmodel) => {
                if (viewmodel.get('actityItemType').getValue() == 0) {
                    delPro();
                }
                let iRange = viewmodel.get("iRange").getValue();
                //平台
                if (iRange == 0) {
                    viewmodel.get('btnImport').setVisible(true);
                    viewmodel.get('btnExport').setVisible(true);
                    // viewmodel.get('btnBatchOp').setVisible(true);
                    viewmodel.get("iAreaId").setVisible(false);
                    viewmodel.get("iAreaId").setValue(null);
                } else {
                    viewmodel.get("iAreaId").setVisible(true);
                    viewmodel.get('btnImport').setVisible(false);
                    viewmodel.get('btnExport').setVisible(false);
                    // viewmodel.get('btnBatchOp').setVisible(false);
                }
            }

            const delPro = () => {
                if (viewmodel.get('productPreferentialPro').getData() && viewmodel.get('productPreferentialPro').getData().length > 0) {
                    let pricenums = viewmodel.get('productPreferentialPro').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('productPreferentialPro').deleteRows(i);
                    }
                }
            }

            viewmodel.get('iAreaId').on('afterValueChange', function (data) {
                common.displayArea(viewmodel);
                if (viewmodel.get('actityItemType').getValue() == 0) {
                    delPro();
                }
            });
            viewmodel.get("iRange").on('afterValueChange', () => {
                displayiAreaId(viewmodel);
            })

            viewmodel.get('bMemberLevelAll').on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            viewmodel.get('enableArchiveDeposite').on('afterValueChange', () => {
                if (viewmodel.get('actityItemType').getValue() == 0) {
                    let PreferentialPro = viewmodel.get('productPreferentialPro');
                    let rows = PreferentialPro.getRows();
                    let enableArchiveDeposite = viewmodel.get("enableArchiveDeposite").getValue();
                    if ("1" == enableArchiveDeposite) {
                        rows.forEach(function (row, index) {
                            PreferentialPro.setCellState(index, 'deposits', 'disabled', true);
                        })
                    } else {
                        if (viewmodel.get('actityItemType').getValue() == 0) {
                            rows.forEach(function (row, index) {
                                if (row.enableDeposit) {
                                    PreferentialPro.setCellState(index, 'deposits', 'disabled', false);
                                }
                            })
                        }
                    }
                }
            })

            viewmodel.get("productPreferentialMemberL").on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            viewmodel.on('beforeEdit', function (args) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_productpromotion');
            })

            viewmodel.on('afterEdit', function (data) {
                common.displayArea(viewmodel);
                common.displayChannel(viewmodel, 'productpromotion');
                common.displayEditButton(viewmodel, "pValid");
            })

            viewmodel.on('afterLoadData', function (data) {
                displayPrice(viewmodel);
                displayIsGetmemberPrice(viewmodel);
                displayBatchControl(viewmodel);
                displayPreferentialPro(viewmodel);
                checkTotalQuantity(viewmodel, true);
                common.displayArea(viewmodel);
                common.displayChannel(viewmodel, 'productpromotion');
                common.hideNoStore(viewmodel);
                common.displayEditButton(viewmodel, "pValid");

                viewmodel.get("productPreferentialPro").getEditRowModel().get('dDiscountNum').setState('min', 0);
                viewmodel.get("productPreferentialPro").getEditRowModel().get('dDiscountNum').setState('max', 10);
                viewmodel.get("productPreferentialPro").getEditRowModel().get('dFireNum').setState('min', 0);
                viewmodel.get("productPreferentialPro").getEditRowModel().get('dNewPrice').setState('min', 0);
                viewmodel.get("productPreferentialPro").getEditRowModel().get('totalQuantity').setState('min', 0);
                viewmodel.get("productPreferentialPro").getEditRowModel().get('deposits').setState('min', 0);
                viewmodel.get("productPreferentialPro").getEditRowModel().get('lTypeNum').setState('min', 0);

                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('iSendPoint').setVisible(true);
                    viewmodel.get('applicableChannel').setValue(["1"]);
                    if (viewmodel.get('actityItemType').getValue() == 1||viewmodel.get('actityItemType').getValue() == 2) {
                        viewmodel.get('priceRule').setDisabled(true);
                    }
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('applicableChannel').setValue(["0"]);
                    viewmodel.get('priceRule').setDisabled(false);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('priceRule').setDisabled(false);
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                }


                // 0 商品  1 商品分类 2商品标签
                if (viewmodel.get('actityItemType').getValue() == 0) {
                    let fieldmap = {};
                    fieldmap.iReferenceName = false;
                    fieldmap.iReferenceName1 = false;
                    displayField(fieldmap);
                } else if (viewmodel.get('actityItemType').getValue() == 1){
                    let fieldmap = {};
                    fieldmap.sProductName = false;
                    fieldmap.sProductCode = false;
                    fieldmap.sProductSkuName = false;
                    fieldmap.sProductSkuCode = false;
                    fieldmap.sProductPicUrl = false;
                    fieldmap.cDescribe = false;
                    fieldmap.dFireNum = false;
                    fieldmap.dNewPrice = false;
                    fieldmap.dPrice = false;
                    fieldmap.deposits = false;
                    fieldmap.lType = false;
                    fieldmap.lTypeNum = false;
                    fieldmap.totalQuantity = false;
                    fieldmap.singleSaleQuantity = false;
                    fieldmap.iReferenceName = true;
                    fieldmap.iReferenceName1 = false;
                    displayField(fieldmap);
                    viewmodel.get('btnImport').setVisible(false);
                    viewmodel.get('btnExport').setVisible(false);
                }else{
                  let fieldmap = {};
                  fieldmap.sProductName = false;
                  fieldmap.sProductCode = false;
                  fieldmap.sProductSkuName = false;
                  fieldmap.sProductSkuCode = false;
                  fieldmap.sProductPicUrl = false;
                  fieldmap.cDescribe = false;
                  fieldmap.dFireNum = false;
                  fieldmap.dNewPrice = false;
                  fieldmap.dPrice = false;
                  fieldmap.deposits = false;
                  fieldmap.lType = false;
                  fieldmap.lTypeNum = false;
                  fieldmap.totalQuantity = false;
                  fieldmap.singleSaleQuantity = false;
                  fieldmap.iReferenceName = false;
                  fieldmap.iReferenceName1 = true;
                  displayField(fieldmap);
                  viewmodel.get('btnImport').setVisible(false);
                  viewmodel.get('btnExport').setVisible(false);
                }

                if (this.get('applyOnlineChannel').getValue() == false) {
                    viewmodel.get("terminalType").setVisible(false);
                } else {
                    viewmodel.get("terminalType").setVisible(true);
                }

                if (this.get('applyOffLineChannel').getValue() == false) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('productpromotionstore').setVisible(false);

                  let newSource = [];
                  dataSource && dataSource.forEach(data => {
                    //置灰商品标签
                    newSource.push({
                      value: data.value,
                      nameType: 'text',
                      text: data.text,
                      disabled: data.value == 2
                    });
                  });
                  auditStatusModel.setDataSource(newSource);
                } else {
                  auditStatusModel.setDataSource(actityItemTypeArray);
                    viewmodel.get('offLineStore').setVisible(true);
                    if (this.get('offLineStore').getValue() == 1 || this.get('offLineStore').getValue() == 0) {
                        viewmodel.get('productpromotionstore').setVisible(false);
                    } else {
                        viewmodel.get('productpromotionstore').setVisible(true);
                    }
                }
                if (this.get('bMemberLevelAll').getValue() == 0) {
                    viewmodel.get('productPreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('productPreferentialMemberL').setVisible(false);
                }
            });

            /**点击按钮弹出参照前事件
             *返回true则继续进行弹出参照操作，返回false则终止弹出
             */
            viewmodel.get("productpromotionstore").on('beforeBrowse', function () {
                return true;
            });

            viewmodel.get('productPreferentialPro').on('beforeBrowse', function (data) {
                if (data.cellName == 'batchNo') {
                    let lProductId = viewmodel.get('productPreferentialPro').getCellValue(data.rowIndex, 'lProductId');
                    let iProductType = viewmodel.get('productPreferentialPro').getCellValue(data.rowIndex, 'iProductType');
                    if (lProductId == undefined) {
                        cb.utils.alert('请选择商品或sku', 'warning');
                        return false;
                    }
                    let batchNo = viewmodel.get('productPreferentialPro').getCellValue(data.rowIndex, 'batchNo');
                    let condition = {
                        "isExtend": true,
                        simpleVOs: []
                    };
                    if (iProductType == 0) {
                        condition.simpleVOs.push({
                            field: 'product',
                            op: 'eq',
                            value1: lProductId
                        });
                    } else {
                        condition.simpleVOs.push({
                            field: 'productsku',
                            op: 'eq',
                            value1: lProductId
                        });
                    }
                    if (batchNo != undefined && batchNo.search(',') > 0) {
                        condition.simpleVOs.push({
                            field: 'batchNo',
                            op: 'in',
                            value1: batchNo.split(',')
                        });
                    }
                    data.context.setFilter(condition);
                } else if (data.cellName != 'iReferenceName'&&data.cellName != 'iReferenceName1') {
                    let areaId;
                    if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                        if (!viewmodel.get("iAreaId").getValue()) {
                            cb.utils.alert('请选择适用区域', 'warning');
                            return false;
                        } else {
                            areaId = viewmodel.get("iAreaId").getValue();
                        }
                    }
                    common.productReferBrowse(viewmodel, data, "sProductCode", "sProductSkuCode", "iProductType",
                        "productPreferentialPro", 'bMemberLevelAll', 'isGetmemberPrice',
                        "productPreferentialMemberL", "lMemberLeverId", false, null, areaId);
                    return true;
                } else {
                    let classId = viewmodel.get('productPreferentialPro').getCellValue(data.rowIndex, 'lProductId');
                    let condition = {
                        "isExtend": true,
                        simpleVOs: []
                    };

                    if (classId && classId != '') {
                        condition.simpleVOs.push({
                            field: 'id',
                            op: 'eq',
                            value1: classId
                        });
                    } else {
                        let exitIds = [];
                        let proClassList = viewmodel.get('productPreferentialPro').getRows();
                        for (let i = 0; i < proClassList.length; i++) {
                            let proClass = proClassList[i];
                            if (proClass.lProductId) {
                                exitIds.push(proClass.lProductId);
                            }
                        }
                        if (exitIds && exitIds.length > 0) {
                            condition.simpleVOs.push({
                                field: 'id',
                                op: 'nin',
                                value1: exitIds
                            });
                        }
                    }
                    data.context.setTreeFilter(condition);
                }
            });

            viewmodel.get('productPreferentialPro').on('beforeInsertRowsFromRefer', function (data) {
                if (data.columnName == 'batchNo') {

                    // let newData = viewmodel.get('productPreferentialPro').getRows()[data.index];
                    let newData = data.rows;
                    var row = {};
                    if (newData) {
                        let nameKey = data.columnName;
                        //商品
                        row[nameKey] = "";
                        for (let i = 0; i < newData.length; i++) {
                            if (newData[i][nameKey] && newData[i][nameKey] != "") {
                                row[nameKey] += newData[i][nameKey];
                                if (i != newData.length - 1)
                                    row[nameKey] += ",";
                            }
                        }
                        data.rows.length = 0;
                        data.rows.push(row);
                    }
                }
            });

            //商品控制单元格是否可修改
            viewmodel.get('productPreferentialPro').on('rowColChange', function (data) {
                if (data.value.columnKey == 'lTypeNum') {
                    if (this.getCellValue(data.value.rowIndex, 'lType') != '4') {
                        return false;
                    }
                }
            });

            viewmodel.get('productPreferentialPro').on('beforeSetColumns', function (data) {
                if (viewmodel.get('actityItemType').getValue() == 0) {
                    let fieldmap = {};
                    fieldmap.iReferenceName = false;
                    fieldmap.iReferenceName1 = false;
                    displayField(fieldmap);
                } else if (viewmodel.get('actityItemType').getValue() == 1){
                    let fieldmap = {};
                    fieldmap.sProductName = false;
                    fieldmap.sProductCode = false;
                    fieldmap.sProductSkuName = false;
                    fieldmap.sProductSkuCode = false;
                    fieldmap.sProductPicUrl = false;
                    fieldmap.cDescribe = false;
                    fieldmap.dFireNum = false;
                    fieldmap.dNewPrice = false;
                    fieldmap.dPrice = false;
                    fieldmap.deposits = false;
                    fieldmap.lType = false;
                    fieldmap.lTypeNum = false;
                    fieldmap.totalQuantity = false;
                    fieldmap.singleSaleQuantity = false;
                    fieldmap.iReferenceName1 = false;
                    displayField(fieldmap);
                }else{
                  let fieldmap = {};
                  fieldmap.sProductName = false;
                  fieldmap.sProductCode = false;
                  fieldmap.sProductSkuName = false;
                  fieldmap.sProductSkuCode = false;
                  fieldmap.sProductPicUrl = false;
                  fieldmap.cDescribe = false;
                  fieldmap.dFireNum = false;
                  fieldmap.dNewPrice = false;
                  fieldmap.dPrice = false;
                  fieldmap.deposits = false;
                  fieldmap.lType = false;
                  fieldmap.lTypeNum = false;
                  fieldmap.totalQuantity = false;
                  fieldmap.singleSaleQuantity = false;
                  fieldmap.iReferenceName = false;
                  displayField(fieldmap);
                }
            });

            viewmodel.get('enableBatchControl').on('afterValueChange', function (data) {
                displayActityItemType(viewmodel);
                displayBatchNo(viewmodel);
            });

            viewmodel.get('actityItemType').on('afterValueChange', function (data) {
                // 0 商品  1 商品分类
                displayBatchControl(viewmodel);
                delPro();
                let fieldmap = {};
                if (data.value.value === '0') {
                    fieldmap.iReferenceName = false;
                    fieldmap.iReferenceName1 = false;
                    fieldmap.sProductName = true;
                    fieldmap.sProductCode = true;
                    fieldmap.sProductSkuName = true;
                    fieldmap.sProductSkuCode = true;
                    fieldmap.sProductPicUrl = true;
                    fieldmap.cDescribe = true;
                    fieldmap.dFireNum = true;
                    fieldmap.dNewPrice = true;
                    fieldmap.dPrice = true;
                    fieldmap.deposits = true;
                    fieldmap.lType = true;
                    fieldmap.lTypeNum = true;
                    fieldmap.totalQuantity = true;
                    fieldmap.singleSaleQuantity = true;
                    displayField(fieldmap);
                    //viewmodel.get('priceRule').setValue(0);
                    viewmodel.get('btnImport').setVisible(true);
                    viewmodel.get('btnExport').setVisible(true);
                    viewmodel.get('priceRule').setDisabled(false);
                    /*if (!viewmodel.get('applyOnlineChannel').getValue() && viewmodel.get('applyOffLineChannel').getValue()) {
                        viewmodel.get('priceRule').setDisabled(false);
                    } else {
                        viewmodel.get('priceRule').setDisabled(true);
                    }*/
                } else if (data.value.value === '1'){
                    fieldmap.iReferenceName = true;
                    fieldmap.iReferenceName1 = false;
                    fieldmap.sProductName = false;
                    fieldmap.sProductCode = false;
                    fieldmap.sProductSkuName = false;
                    fieldmap.sProductSkuCode = false;
                    fieldmap.sProductPicUrl = false;
                    fieldmap.cDescribe = false;
                    fieldmap.dFireNum = false;
                    fieldmap.dNewPrice = false;
                    fieldmap.dPrice = false;
                    fieldmap.deposits = false;
                    fieldmap.lType = false;
                    fieldmap.lTypeNum = false;
                    fieldmap.totalQuantity = false;
                    fieldmap.singleSaleQuantity = false;
                    displayField(fieldmap);
                    viewmodel.get('priceRule').setValue(1);
                    viewmodel.get('priceRule').setDisabled(true);
                    viewmodel.get('btnImport').setVisible(false);
                    viewmodel.get('btnExport').setVisible(false);
                }else if (data.value.value === '2'){
                    fieldmap.iReferenceName = true;
                    fieldmap.iReferenceName1 = false;
                    fieldmap.sProductName = false;
                    fieldmap.sProductCode = false;
                    fieldmap.sProductSkuName = false;
                    fieldmap.sProductSkuCode = false;
                    fieldmap.sProductPicUrl = false;
                    fieldmap.cDescribe = false;
                    fieldmap.dFireNum = false;
                    fieldmap.dNewPrice = false;
                    fieldmap.dPrice = false;
                    fieldmap.deposits = false;
                    fieldmap.lType = false;
                    fieldmap.lTypeNum = false;
                    fieldmap.totalQuantity = false;
                    fieldmap.singleSaleQuantity = false;
                    displayField(fieldmap);
                    viewmodel.get('priceRule').setValue(1);
                    viewmodel.get('priceRule').setDisabled(true);
                    viewmodel.get('btnImport').setVisible(false);
                    viewmodel.get('btnExport').setVisible(false);
                }else{
                  fieldmap.iReferenceName = false;
                  fieldmap.iReferenceName1 = true;
                  fieldmap.sProductName = false;
                  fieldmap.sProductCode = false;
                  fieldmap.sProductSkuName = false;
                  fieldmap.sProductSkuCode = false;
                  fieldmap.sProductPicUrl = false;
                  fieldmap.cDescribe = false;
                  fieldmap.dFireNum = false;
                  fieldmap.dNewPrice = false;
                  fieldmap.dPrice = false;
                  fieldmap.deposits = false;
                  fieldmap.lType = false;
                  fieldmap.lTypeNum = false;
                  fieldmap.totalQuantity = false;
                  fieldmap.singleSaleQuantity = false;
                  displayField(fieldmap);
                  //viewmodel.get('priceRule').setValue(1);
                  viewmodel.get('priceRule').setDisabled(false);
                  viewmodel.get('btnImport').setVisible(false);
                  viewmodel.get('btnExport').setVisible(false);
                }
            })

            //商品单元格改变后事件
            viewmodel.get('productPreferentialPro').on('afterCellValueChange', function (data) {
                var price = this.getCellValue(data.rowIndex, 'dPrice');
                var dDiscountNum = this.getCellValue(data.rowIndex, 'dDiscountNum');
                var dFireNum = this.getCellValue(data.rowIndex, 'dFireNum');
                var dNewPrice = this.getCellValue(data.rowIndex, 'dNewPrice');
                if (viewmodel.get('actityItemType').getValue() == 0) {
                    if (data.cellName == 'dDiscountNum') {
                        if (!price) {
                            this.setCellValue(data.rowIndex, 'dFireNum', 0.00);
                            this.setCellValue(data.rowIndex, 'dNewPrice', 0.00);
                        } else {
                            var tempNewPrice = cb.utils.getRoundValue((price * data.value / 10), 2);
                            this.setCellValue(data.rowIndex, 'dFireNum', cb.utils.getRoundValue((price - tempNewPrice), 2));
                            this.setCellValue(data.rowIndex, 'dNewPrice', tempNewPrice);
                        }
                    } else if (data.cellName == 'dFireNum') {
                        if (data.value) {
                            if (data.value <= 0 || data.value >= price) {
                                cb.utils.alert('请输入正确的减价数量', 'warning');
                                this.setCellValue(data.rowIndex, 'dFireNum', data.oldValue);
                            } else {
                                if (!price) {
                                    this.setCellValue(data.rowIndex, 'dDiscountNum', 0.00);
                                    this.setCellValue(data.rowIndex, 'dNewPrice', 0.00);
                                } else {
                                    this.setCellValue(data.rowIndex, 'dDiscountNum', (10 - data.value * 10 / price).toFixed(2));
                                    this.setCellValue(data.rowIndex, 'dNewPrice', (price - data.value).toFixed(2));
                                }
                            }
                        }
                    } else if (data.cellName == 'dNewPrice') {
                        if (data.value) {
                            if (data.value <= 0 || data.value >= price) {
                                cb.utils.alert('请输入正确的折后价', 'warning');
                                this.setCellValue(data.rowIndex, 'dNewPrice', data.oldValue);
                            } else {
                                if (!price) {
                                    this.setCellValue(data.rowIndex, 'dDiscountNum', 0.00);
                                    this.setCellValue(data.rowIndex, 'dFireNum', 0.00);
                                } else {
                                    this.setCellValue(data.rowIndex, 'dDiscountNum', (data.value * 10 / price).toFixed(2));
                                    this.setCellValue(data.rowIndex, 'dFireNum', (price - data.value).toFixed(2));
                                }
                            }
                        }
                    } else if (data.cellName === 'sProductCode') {
                        this.setCellValue(data.rowIndex, 'iProductType', 0);
                        this.setCellValue(data.rowIndex, 'sProductSkuName', null);
                        this.setCellValue(data.rowIndex, 'sProductSkuCode', null);
                        if (this.getCellValue(data.rowIndex, 'dFireNum') > price) {
                            this.setCellValue(data.rowIndex, 'dFireNum', 0.00);
                        }
                        if (dDiscountNum) {
                            var tempNewPrice = cb.utils.getRoundValue((price * dDiscountNum / 10), 2);
                            this.setCellValue(data.rowIndex, 'dFireNum', cb.utils.getRoundValue(price - tempNewPrice, 2));
                            this.setCellValue(data.rowIndex, 'dNewPrice', tempNewPrice);
                        } else {
                            this.setCellValue(data.rowIndex, 'dFireNum', 0);
                            this.setCellValue(data.rowIndex, 'dNewPrice', 0);
                        }
                    } else if (data.cellName === 'sProductSkuCode') {
                        this.setCellValue(data.rowIndex, 'iProductType', 1);
                        if (this.getCellValue(data.rowIndex, 'dFireNum') > price) {
                            this.setCellValue(data.rowIndex, 'dFireNum', 0.00);
                        }
                        if (dDiscountNum) {
                            var tempNewPrice = cb.utils.getRoundValue((price * dDiscountNum / 10), 2);
                            this.setCellValue(data.rowIndex, 'dFireNum', cb.utils.getRoundValue(price - tempNewPrice, 2));
                            this.setCellValue(data.rowIndex, 'dNewPrice', tempNewPrice);

                        } else {
                            this.setCellValue(data.rowIndex, 'dFireNum', 0);
                            this.setCellValue(data.rowIndex, 'dNewPrice', 0);
                        }
                    }
                } else if (data.cellName === 'iReferenceName') {
                    this.setCellValue(data.rowIndex, 'iProductType', 2);
                }else if (data.cellName === 'iReferenceName1') {
                  this.setCellValue(data.rowIndex, 'iProductType', 3);
                }
                displayPreferentialPro(viewmodel);
            });

            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
              viewmodel.get('terminalType').setVisible(false);
              viewmodel.get('offLineStore').setVisible(false);
              viewmodel.get('productpromotionstore').setVisible(false);
              viewmodel.get('applyOnlineChannel').setValue(false);
              viewmodel.get('applyOffLineChannel').setValue(false);
              viewmodel.get('iSendPoint').setVisible(false);
              viewmodel.get('priceRule').setDisabled(true);
              var on = 0;
              for (var i = 0; i < data.value.length; i++) {
                if (data.value[i].value == 0) {
                  viewmodel.get('terminalType').setVisible(true);
                  viewmodel.get('applyOnlineChannel').setValue(true);
                  viewmodel.get('iSendPoint').setVisible(false);
                  viewmodel.get('priceRule').setDisabled(true);
                  /*if (viewmodel.get('actityItemType').getValue() == 0) {
                      viewmodel.get('priceRule').setValue(0);
                  }*/
                  on = 1;
                }
                if (data.value[i].value == 1) {
                  viewmodel.get('applyOffLineChannel').setValue(true);
                  viewmodel.get('offLineStore').setVisible(true);
                  if (viewmodel.get('promotionParams')) {
                    let userType = viewmodel.get('promotionParams').userType;
                    //超级管理员
                    if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                      viewmodel.get('offLineStore').setValue(2);
                    }
                  }
                  if (viewmodel.get('offLineStore').getValue() == 1) {
                    viewmodel.get('productpromotionstore').setVisible(false);
                  } else {
                    viewmodel.get('productpromotionstore').setVisible(true);
                  }
                  if (on == 0) {
                    viewmodel.get('iSendPoint').setVisible(true);
                    /*if (viewmodel.get('actityItemType').getValue() == 0) {
                        viewmodel.get('priceRule').setDisabled(false);
                    }*/
                  }
                }
                if (viewmodel.get('actityItemType').getValue() == 0) {
                  viewmodel.get('priceRule').setDisabled(false);
                }
              }
              if (!viewmodel.get('applyOffLineChannel').getValue()) {
                viewmodel.get('actityItemType').setValue(0);
                displayBatchControl(viewmodel);
                delPro();
                let fieldmap = {};
                fieldmap.iReferenceName = false;
                fieldmap.iReferenceName1 = false;
                fieldmap.sProductName = true;
                fieldmap.sProductCode = true;
                fieldmap.sProductSkuName = true;
                fieldmap.sProductSkuCode = true;
                fieldmap.sProductPicUrl = true;
                fieldmap.cDescribe = true;
                fieldmap.dFireNum = true;
                fieldmap.dNewPrice = true;
                fieldmap.dPrice = true;
                fieldmap.deposits = true;
                fieldmap.lType = true;
                fieldmap.lTypeNum = true;
                fieldmap.totalQuantity = true;
                fieldmap.singleSaleQuantity = true;
                displayField(fieldmap);
                //viewmodel.get('priceRule').setValue(0);
                viewmodel.get('btnImport').setVisible(true);
                viewmodel.get('btnExport').setVisible(true);
                /*if (!viewmodel.get('applyOnlineChannel').getValue() && viewmodel.get('applyOffLineChannel').getValue()) {
                  viewmodel.get('priceRule').setDisabled(false);
                } else {
                  viewmodel.get('priceRule').setDisabled(true);
                }*/
                viewmodel.get('priceRule').setDisabled(false);
                let newSource = [];
                dataSource && dataSource.forEach(data => {
                  newSource.push({
                    value: data.value,
                    nameType: 'text',
                    text: data.text,
                    disabled: data.value == 2
                  });
                });
                auditStatusModel.setDataSource(newSource);
              } else {
                auditStatusModel.setDataSource(actityItemTypeArray);
              }
              displayBatchControl(viewmodel);
              displayActityItemType(viewmodel);
              displayPrice(viewmodel);
              checkTotalQuantity(viewmodel, false);
            });

            //买家范围控制事件
            viewmodel.get('bMemberLevelAll').on('afterValueChange', function (data) {
                if (data.value.value === '0') {
                    viewmodel.get("productPreferentialMemberL").setVisible(true);
                } else {
                    viewmodel.get('productPreferentialMemberL').setVisible(false);
                }
            });

            //线下门店控制事件
            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value === '1') {
                    viewmodel.get("productpromotionstore").setVisible(false);
                } else {
                    viewmodel.get('productpromotionstore').setVisible(true);
                }
            });

            viewmodel.on('batchModifySetFields', function (args) {
                debugger
                args.forEach((item, index) => {
                    if (item.fieldName === 'sProductCode' || item.fieldName === 'lTypeNum' || item.fieldName === 'totalQuantity' || item.fieldName === 'dNewPrice' || item.fieldName === 'deposits' || item.fieldName === 'iReferenceName') {
                        item.bCanModify = false;
                    } else if (item.fieldName === 'sProductPicUrl') {
                        item.bCanFilter = false;
                    } else if (item.fieldName === 'sProductSkuName') {
                        item.bCanFilter = true;
                    } else if (item.fieldName === 'sProductSkuCode') {
                        item.bCanFilter = true;
                        item.bCanModify = false;
                    } else if (item.fieldName === 'dFireNum') {
                        if (viewmodel.get('actityItemType').getValue() == 1||viewmodel.get('actityItemType').getValue() == 2) {
                            item.bCanModify = false;
                        }
                    }
                })
            })

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('productPreferentialPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("productPreferentialPro").deleteRows(rowIndexes);
            })


            viewmodel.on('statictempexport', function (params) {
                const openUrl = params && params.cSvcUrl;
                if (!openUrl) {
                    cb.utils.alert('导出模板的地址为空', 'error');
                    return;
                }
                window.open(openUrl);
            });

            viewmodel.on('batchimport', function (params) {
                const url = `${params.cSvcUrl}?token=${cb.rest.AppContext.token}&billnum=pmc_productpromotion`;
                const eleInput = document.createElement('input');
                eleInput.type = 'file';
                eleInput.style.display = 'none';
                eleInput.onchange = function (e) {
                    const formData = new FormData();
                    formData['enctype'] = 'multipart/form-data';
                    formData.append('file', e.target.files[0]);

                    var param = {};
                    param.type = 1;
                    param.applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    param.applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    if (viewmodel.get("isGetmemberPrice").getValue() == '1') {
                        param.memberLevelId = viewmodel.get("productPreferentialMemberL").get("lMemberLeverId")
                    }
                    formData.append('data', JSON.stringify(param));

                    cb.utils.alert(`导入中，请稍后`, 'info');

                    const xhr = new XMLHttpRequest();
                    xhr.open('POST', url, true);
                    xhr.send(formData);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState !== 4) return;
                        if (xhr.status === 200) {
                            var ajaxResult = JSON.parse(xhr.responseText);
                            if (ajaxResult.code === 200) {
                                if (ajaxResult.data.code === 200) {
                                    var array = [];
                                    var res = ajaxResult.data.data;
                                    var gridModel = viewmodel.get("productPreferentialPro");
                                    for (let i = 0; i < res.data.length; i++) {
                                        var appendData = {};
                                        var data = res.data[i];
                                        appendData.iProductType = data.iProductType;
                                        if (appendData.iProductType == 0) {
                                            appendData.sProductCode = data.cCode;
                                            appendData.sProductName = data.sProductName;
                                        } else {
                                            appendData.sProductCode = data.productCode;
                                            appendData.sProductName = data.productName;
                                            appendData.sProductSkuCode = data.cCode;
                                            appendData.sProductSkuName = data.sProductName;
                                        }
                                        appendData.dPrice = data.dPrice;
                                        if (data.dNewPrice > 0) {
                                            appendData.dNewPrice = data.dNewPrice;
                                            if (appendData.dPrice == 0) {
                                                appendData.dDiscountNum = 0;
                                            } else {
                                                appendData.dDiscountNum = (appendData.dNewPrice / appendData.dPrice) * 10;
                                            }
                                            appendData.dFireNum = appendData.dPrice - appendData.dNewPrice;
                                        }
                                        appendData.deposits = data.deposits;
                                        appendData.enableDeposit = data.enableDeposit;
                                        appendData.lProductId = data.lProductId;
                                        appendData.sProductPicUrl = data.sProductPicUrl;
                                        appendData.singleSaleQuantity = data.singleSaleQuantity;
                                        array.push(appendData);
                                        // gridModel.appendRow(appendData);
                                    }
                                    let count = gridModel.getRowsCount();
                                    var indexes = [];
                                    for (let i = count - 1; i >= 0; i--) {
                                        indexes.push(i);
                                    }
                                    gridModel.deleteRows(indexes);
                                    gridModel.insertRows(0, array);
                                    var errorMessages = '';
                                    if (res.errorCount) {
                                        for (let i = 0; i < res.allMsgs.length; i++) {
                                            if (res.allMsgs[i].isError) {
                                                errorMessages += res.allMsgs[i].msg;
                                            }
                                        }
                                    }
                                    cb.utils.alert(`共导入${res.totalCount}条, 成功${res.successCount}条, 失败${res.errorCount}条${res.errorCount ? `失败原因是: ${res.errorMsgs + errorMessages}` : ''}`, res.errorCount ? 'error' : 'success');
                                } else {
                                    cb.utils.alert(`${ajaxResult.data.message}，模板内容导入失败`, 'error');
                                }
                            } else {
                                cb.utils.alert(`${ajaxResult.message}，模板内容导入失败`, 'error');
                            }
                        }
                    };
                    document.body.removeChild(eleInput);
                };
                document.body.appendChild(eleInput);
                eleInput.click();
            });

            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                obj.activityType = setCheckBoxEnum(obj.activityType);

                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue() || viewmodel.get("iAreaId").getValue() == 0) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    }
                }

                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }
                // else if (this.get('applyOnlineChannel').getValue() == '0') {
                //                 obj.terminalType = 7;
                //             }

                if (this.get('bMemberLevelAll').getValue() == '0' && this.get('productPreferentialMemberL').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('bMemberLevelAll').getValue() != '0') {
                    obj.productPreferentialMemberL = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('productpromotionstore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (obj.bMemberLevelAll == 1) {
                        obj.bMemberLevelAll = 2;
                    }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.productpromotionstore = [];
                }
                // else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '0') {
                //                 cb.utils.alert('线下门店不能为空', 'warning');
                //                 return false;
                //             }
                // if (mode == 'add') {
                //     if (viewmodel.get('pStartDate').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }

                if (this.get('pStartDate').getValue() >= this.get('pEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                if (viewmodel.get('productPreferentialPro').getRows() == '') {
                  switch (obj.actityItemType) {
                    case '0':
                    case 0:
                      cb.utils.alert('商品信息不能为空', 'warning');
                      return false;
                    case '1':
                    case 1:
                      cb.utils.alert('分类信息不能为空', 'warning');
                      return false;
                    case '2':
                    case 2:
                      cb.utils.alert('标签信息不能为空', 'warning');
                      return false;
                  }
                } else {
                    for (var i = 0; i < viewmodel.get('productPreferentialPro').getRows().length; i++) {
                        if (viewmodel.get('productPreferentialPro').getCellValue(i, 'lType') == 4) {
                            if (!viewmodel.get('productPreferentialPro').getCellValue(i, 'lTypeNum') || viewmodel.get('productPreferentialPro').getCellValue(i, 'lTypeNum') == 0) {
                                cb.utils.alert('请输入第' + (i + 1) + '行自定限购的限购数量', 'warning');
                                return false;
                            }
                            if (viewmodel.get("productPreferentialPro").getRows()[i].totalQuantity == undefined) {
                                viewmodel.get("productPreferentialPro").getRows()[i].totalQuantity = null;
                            }
                        }
                        if (viewmodel.get('productPreferentialPro').getCellValue(i, 'dDiscountNum') < 0 || viewmodel.get('productPreferentialPro').getCellValue(i, 'dDiscountNum') > 10) {
                            cb.utils.alert('请正确输入第' + (i + 1) + '行折扣', 'warning');
                            return false;
                        }
                        if (viewmodel.get('productPreferentialPro').getCellValue(i, 'dFireNum') < 0) {
                            cb.utils.alert('请正确输入第' + (i + 1) + '行减价', 'warning');
                            return false;
                        }
                        if (viewmodel.get('productPreferentialPro').getCellValue(i, 'dNewPrice') < 0) {
                            cb.utils.alert('请正确输入第' + (i + 1) + '行折后价', 'warning');
                            return false;
                        }
                        // if (viewmodel.get('productPreferentialPro').getCellValue(i, 'dDiscountNum') == 0) {
                        //     cb.utils.alert('第' + (i + 1) + '行折扣为0', 'warning');
                        //     return false;
                        // }
                        if (viewmodel.get('actityItemType').getValue() == 0) {
                            if (viewmodel.get('productPreferentialPro').getCellValue(i, 'enableDeposit')) {
                                if (!viewmodel.get('productPreferentialPro').getCellValue(i, 'deposits')) {
                                    cb.utils.alert('第' + (i + 1) + '行商品定金不能为空', 'warning');
                                    return false;
                                }
                                if (viewmodel.get('productPreferentialPro').getCellValue(i, 'dNewPrice') <
                                    viewmodel.get('productPreferentialPro').getCellValue(i, 'deposits')) {
                                    cb.utils.alert('第' + (i + 1) + '行商品定金不能大于折后价', 'warning');
                                    return false;
                                }
                            }
                            if (!viewmodel.get('productPreferentialPro').getCellValue(i, 'sProductName')) {
                                cb.utils.alert('请输入' + (i + 1) + '行商品名称', 'warning');
                                return false;
                            }
                        } else if (viewmodel.get('actityItemType').getValue() == 1){
                            if (!viewmodel.get('productPreferentialPro').getCellValue(i, 'iReferenceName')) {
                                cb.utils.alert('请输入' + (i + 1) + '行商品分类名称', 'warning');
                                return false;
                            }
                        }else {
                          if (!viewmodel.get('productPreferentialPro').getCellValue(i, 'iReferenceName1')) {
                            cb.utils.alert('请输入' + (i + 1) + '行商品标签名称', 'warning');
                            return false;
                          }
                        }
                        if (viewmodel.get('enableBatchControl').getValue() == 1) {
                            if (!viewmodel.get('productPreferentialPro').getCellValue(i, 'batchNo')) {
                                cb.utils.alert('请输入' + (i + 1) + '行批号', 'warning');
                                return false;
                            }
                        }
                    }
                    if (obj.productPreferentialPro) {
                        for (var i = 0; i < obj.productPreferentialPro.length; i++) {
                            if (obj.productPreferentialPro[i].lTypeNum == null) {
                                obj.productPreferentialPro[i].lTypeNum = 0;
                            }
                            if (obj.productPreferentialPro[i].totalQuantity == undefined) {
                                obj.productPreferentialPro[i].totalQuantity = null;
                            }
                        }
                    }

                }

                data.data.data = JSON.stringify(obj);
            });
        }
    };
    try {
        module.exports = PM_pmc_productpromotion_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_productpromotion_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_productpromotion_VM.Extend.js